<template>
  <div class="col-12 flex flex-wrap justify-center p2">
    <div class="col-12 relative flex flex-wrap justify-center">
      <div v-for="(document, index) in requiredDocuments" :key="index" class="col-12">
        <form
          :id="`id-form-${document.type}`"
          class="col-12 border-bottom border-top flex flex-wrap items-center no-box p1 my1"
          enctype="multipart/form-data"
        >
          <div class="col-12 absolute top-0 mt2 mr1 flex justify-end">
            <i :class="['absolute h6 red icon mr3', { 'icon-attention': !document.valid }] "></i>
          </div>

          <label class="flex items-center file-upload-label" :for="`file-upload-${document.type}`">
            <div
              v-if="!loading && !document.valid"
              :class="['p2 border-dashed mr2 flex items-center pointer justify-center pointer file-upload full-height file-upload-div', { 'disabled': loading }]"
            >
              <div class="status avatar flex items-center justify-center">
                <i class="h3 grey icon icon-upload"></i>
              </div>
            </div>
          </label>

          <!-- document is valid -->
          <div v-if="document.valid" class="p2 flex items-center justify-center mr2 file-upload">
            <span class="circle avatar green-bg col-12 flex justify-center grey items-center">
              <i class="h3 white line-height-1 icon icon-check"></i>
            </span>
          </div>

          <!-- Loading -->
          <div v-if="loading" class="p2 flex items-center justify-center mr2 file-upload">
            <div class="loading-animate file-upload">
              <div class="dot avatar grey-bg"></div>
            </div>
          </div>

          <input
            :id="`file-upload-${document.type}`"
            name="fileupload"
            type="file"
            hidden
            @change="uploadDocument(document, $event)"
          >
          <!-- data-amp-bind-disabled="formSubmit"
          on="tap: AMP.setState({ docType: '{{type}}' }), id-form-{{type}}.clear; change: id-form-{{type}}.submit, AMP.setState({ uploading: 'file-upload-{{type}}' });" -->

          <div class="upload-form-body">
            <div class="col-12 no-box h5 py1">
              <h4 class="my1">{{ document.name }}</h4>
              <h5 class="my0 regular">documents acceptés:</h5>
              <span v-for="(allowedDocument, index) in document.allowed_documents" :key="index">{{ allowedDocument }}{{ index === (document.allowed_documents.length - 1) ? '.' : ',' }} </span>
              <h5 class="regular mt1 italic mb0">
                *veuillez envoyer les documents au format
                <span v-for="(allowedFormat, index) in document.allowed_formats" :key="index">{{ allowedFormat }}{{ index === (document.allowed_formats.length - 1) ? '.' : ',' }} </span>
                et moins de <span class="bold">{{ document.max_document_size }} Mo</span>
              </h5>
            </div>
          </div>

          <div v-if="errorMessages.active">
            <div v-if="errorMessages.messages" class="block h6 pt1 red bold regular">
              <div v-for="(message, index) in errorMessages.messages" :key="index">
                <i class="h6 red icon mx1 mt1 icon-attention"></i><span class="bold">{{ message.errorMessage }}</span>
              </div>
            </div>
            <div data-amp-bind-hidden="doc.success != false" class="block h6 pt1 red bold regular">
              <i class="h6 red icon mx1 mt1 icon-attention"></i><span class="bold">Cliquez sur le bouton “SUIVANT” pour poursuivre votre achat, un justificatif pour ce tarif vous sera demandé sur place.</span>
            </div>
          </div>

          <!-- <div class="col-12" template="errorLst" submit-error></div> -->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadRequiredDocuments } from '@/utils/requests';

export default {
  props: { currentParticipant: Object },
  data () {
    return {
      loading: false,
      errorMessages: { active: false, messages: null }
    };
  },
  computed: {
    requiredDocuments () {
      return this.currentParticipant.tariff.documents.required_documents;
    }
  },
  methods: {
    async uploadDocument (document, event) {
      this.loading = true;

      const file = event.target.files[0];

      const formData = new FormData();
      formData.append('fileupload', file);

      formData.append('useruuid', this.currentParticipant.uuid);
      formData.append('tariff', this.currentParticipant.tariff.tariffCategoryCode);
      formData.append('document_type', document.type);
      formData.append('workspace', this.$store.getters.workspace);

      // TODO - Implement file upload
      await uploadRequiredDocuments(formData).then(res => {
        if (res.errors) {
          this.errorMessages = {
            active: true,
            messages: res.errors
          };
        }

        if (res.success) {
          // Test it BETTER!!!!
          const { currentParticipant } = this;
          currentParticipant.tariff.documents = res.participantDocs;
          this.$store.commit('setCurrentParticipant', currentParticipant);
        }
      }).catch(() => {
        this.errorMessages = { active: true };
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .file-upload-label{
    height: 106px;
  }

  .file-upload-div{
    width: 90px;
  }
</style>
